import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Trophy, Swords, Building2 } from 'lucide-react';

const ICONS = { match: Swords, league: Trophy, bookmaker: Building2 };

export default function InternalLinks({ links }) {
  const { t } = useTranslation();
  if (!links || links.length === 0) return null;

  return (
    <div className="border border-slate-800/50 rounded-xl p-4 mt-6" data-testid="internal-links">
      <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">
        Related
      </h3>
      <div className="flex flex-wrap gap-2">
        {links.filter(l => l.url).map((link, i) => {
          const Icon = ICONS[link.type] || ArrowRight;
          return (
            <Link key={i} to={link.url}
              className="flex items-center gap-1.5 text-xs text-slate-400 hover:text-emerald-400 bg-slate-900/50 hover:bg-slate-800/50 border border-slate-800/50 rounded-lg px-3 py-1.5 transition-colors"
              data-testid={`internal-link-${i}`}>
              <Icon className="w-3 h-3" />
              <span className="truncate max-w-[200px]">{link.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
